module.exports = __webpack_public_path__ + "static/media/4.3.0eb90b6b.png";